<template>
  <v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
    <v-dialog v-model="permitted_dialog" max-width="400px">
      <v-card>
        <v-card-text>
          <div class="text-center">
            <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
            <p>{{message}}</p>
            <v-progress-circular
              :size="70"
              :width="2"
              :value="100"
              color="error"
              class="mb-4 mr-4"
            >
              <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
            </v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
  <v-container v-else v-show="permitted != null" class="pt-0" fluid>
    <v-snackbar
      :value="showMessage()"
      multi-line
      color="#686868"
      top
      
    >
      {{message}}
    </v-snackbar>
    <v-card flat>
    <v-toolbar dense flat color="#2A353D">
      <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Dividend Settlements</v-toolbar-title>
      <v-spacer/>
      <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    </v-card>
    <v-data-table
      disable-pagination
      hide-default-footer
      :height="520"
      fixed-header
      :headers="headers"
      :items="Settlements"
      :search="search"
      class="elevation-12 mt-2"
      @current-items="getFiltered"
    >
        <template v-slot:top >
        <!-- <v-form class="edit rounded-t-xl elevation-6" ref="form" v-model="valid" lazy-validation v-if="create">
          <v-toolbar dense flat color="#DBEFFA">
            <v-toolbar-title class="grey--text subtitle-1 font-weight-normal">Create New Activation</v-toolbar-title>
            <v-spacer/>
          </v-toolbar>
          <v-row class="ml-1 mr-1">
          <v-col>
            <v-text-field
              dense filled
              color="#2A353D"
              v-model="activation.ActivationCode"
              label="Activation Code"
              required
              :rules="TextFieldRules"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              light dense filled
              color="#2A353D"
              v-model="activation.ActivationReason"
              label="Reason"
              required
              :rules="TextFieldRules"
            ></v-text-field>           
          </v-col>
          <v-col>
            <div class="text-right mt-7">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="closeCreate()">close</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" :disabled="!valid" @click="createNew()">submit</v-btn>          
            </div>   
          </v-col>
          </v-row>
          <v-divider class="mt-0"/>
        </v-form>

        <v-form class="edit rounded-t-xl elevation-6" ref="form" v-model="valid" lazy-validation v-if="edit" >
          <v-toolbar dense flat color="#DBEFFA">
            <v-toolbar-title class="d-flex flex-row grey--text subtitle-1 font-weight-normal">Activation: {{currentSettlement.ActivationCode.toUpperCase()}}</v-toolbar-title>
              <v-spacer/>
              <span class="mr-2 grey--text caption font-weight-normal">Maker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentSettlement.MakerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
              <span v-if="currentSettlement.CheckerID != 0" class="mx-2 grey--text caption font-weight-normal">Checker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentSettlement.CheckerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
              <span class="ml-2 grey--text caption font-weight-normal">Last User: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentSettlement.LastUserID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
          </v-toolbar>
          <v-row class="ml-1 mr-1">
          <v-col>
            <v-text-field
              dense filled
              color="#2A353D"
              v-model="currentSettlement.ActivationCode"
              label="Activation Code"
              :readonly="view"
              required
              :rules="TextFieldRules"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              light dense filled
              color="#2A353D"
              v-model="currentSettlement.ActivationReason"
              label="Reason"
              :readonly="view"
              required
              :rules="TextFieldRules"
            ></v-text-field>           
          </v-col>
          <v-col>
            <div class="text-right mt-7">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="view = false; closeEdit()">close</v-btn>
              <v-btn class="white--text mr-3" v-if="!view" small color="#2A353D" @click="update()">save</v-btn>          
            </div>   
          </v-col>
          </v-row>
          <v-divider class="mt-0"/>
        </v-form> -->
        <v-container row>

          <v-text-field
            class="ml-3"
            hide-details
            outlined
            placeholder="search..."
            v-model="search"
            append-icon="mdi-magnify"
            dense
          ></v-text-field>

          <v-spacer></v-spacer>

          <!-- <v-btn v-if="showCreateBtn == true" v-show="confirmedActivations" @click="showCreate(); closeEdit()" outlined small color="#2A353D" class="ml-2">
            Create New<v-icon small>mdi-plus</v-icon>
          </v-btn>
          <v-menu open-on-hover offset-y>
            <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" v-if="confirmedActivations" outlined small color="#2A353D" class="ml-2">
              EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
            </v-btn>
            </template>
            <v-list dense>
            <v-list-item class="ma-0 pa-0">
              <v-btn text small color="#2A353D">
                <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
              </v-btn>
            </v-list-item>
            <v-list-item class="ma-0 pa-0">
              <v-btn text small color="#2A353D">
                <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
              </v-btn>
            </v-list-item>
            <v-list-item class="ma-0 pa-0">
              <v-btn text small color="#2A353D">
                <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
              </v-btn>
            </v-list-item>
            </v-list>
          </v-menu>
          <v-btn v-if="confirmedActivations" outlined small color="#2A353D" class="ml-2" v-on="on">
            PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
          </v-btn>
          <v-btn v-if="!confirmedActivations" @click="confirmedActivations = true" outlined small color="#2A353D" class="ml-2" v-on="on">
            ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
          </v-btn> -->
        </v-container>
      </template>

      <template v-slot:item.actions="{ item }">
        <!-- <v-tooltip v-if="!confirmedActivations && item.CheckerID == 0" top>
          <template v-slot:activator="{ on }">
          <v-btn
            small @click="setActiveSettlement(item, index); updateStatus()"
            outlined :disabled="showConfirmBtn == false"
            v-on="on"
            color="#2A353D" class="mr-3"
          >
            confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
          </v-btn>
          </template>
          <span>confirm</span>
        </v-tooltip>
        <v-tooltip v-if="!confirmedActivations && item.CheckerID == 0" top>
          <template v-slot:activator="{ on }">
          <v-btn
            small @click="setActiveSettlement(item, index); rejectionDialog = true"
            outlined :disabled="showConfirmBtn == false"
            v-on="on"
            color="#2A353D" class="mr-3"
          >
            reject<v-icon class="ml-1" color="#2A353D">mdi-close-circle-outline</v-icon>
          </v-btn>
          </template>
          <span>reject</span>
        </v-tooltip> -->
        <v-btn
          small outlined :disabled="edit" v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
          @click="setActiveSettlement(item, index); settle(item)"
          color="#2A353D" class="mr-3"
        >
          <span>paid</span>
        </v-btn>
        <!-- <v-btn
          small outlined
          :disabled="edit"
          @click="view = true; setActiveSettlement(item, index); showEdit(); closeCreate()"
          color="#2A353D" class="mr-3"
        >
          <span>view</span>
        </v-btn>
        <v-icon
          :disabled="(item.MakerID == currentUser.SecurityUserID && item.CheckerID == 0) || showDeleteBtn == false ? false : true"
          color="#2A353D" @click="setActiveSettlement(item, index); deleteDialog = true"
        >
        mdi-trash-can-outline
        </v-icon> -->
      </template>

      <template v-slot:item.EffectedDate="{ item }">
        {{ item.EffectedDate | moment("YYYY-MM-DD") }}
      </template>

      <template v-slot:item.PerShare="{ item }">
        {{Number(item.PerShare).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
      </template>

      <template v-slot:item.Value="{ item }">
        {{ Number(item.Value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
      </template>

    </v-data-table>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";
import transactionService from '../services/transaction.service';
import UserService from '../services/user.service';

export default {

  data () {
    return {
      confirmedActivations: true,
      edit: false,
      create: false,
      view: false,
      rejectionDialog: false,
      deleteDialog: false,
      permitted: null,
      permitted_dialog: true,
      RejectionStatus: 0,
      message: '',
      search: '',
      valid: true,
      content: '',
      currentSettlement: null,
      currentIndex: -1,
      CurrentDataset: [],
      headers: [
        { text: 'Client Name', value: 'ClientName', sortable: false },
        { text: 'Counter Name', value: 'CounterName', sortable: false },
        { text: 'Dividend Rate', value: 'PerShare', sortable: false },
        { text: 'Payment Date', value: 'EffectedDate', sortable: false },
        { text: 'Tax', value: 'Tax', sortable: false },
        { text: 'Value', value: 'Value', sortable: false },
        { value: 'actions', sortable: false, align: 'end' },
      ],
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
      Settlements: [],
      submitted: false,
    }
  },

  computed: {
    ...mapGetters(["allActivations", "allRejectionReasons", "allUsers"]),
    currentUser() {
      return this.$store.state.auth.user;
    },
    showDeleteBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 3025).map(r => r.AllowDelete)) == 1){
        return true
      }
    }
    return false;
    },

    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 3025).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 3025).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 3025).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },
  },

  created () {
    transactionService.getAllDividendSettlements()
    .then(response => {
      this.Settlements = response.data
    })
  },

  methods: {
    // ...mapActions([
    //   "createActivation",
    //   "updateActivation",
    //   "deleteActivation"
    // ]),

    settle(item){
      this.message = '';
      transactionService.updateDividendSettlement(item)
      .then(response => {
        if(response.data[0].ResultCode == 0){
          this.message = "Settled succesfully"
          const index = this.Settlements.findIndex(s => s.PurchaseAllocationID == item.PurchaseAllocationID);
          if (index !== -1) {
            this.Settlements.splice(index, 1);
          }
        }
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    getFiltered(current){
      this.CurrentDataset = current;
    },

    // async createNew() {
    //   this.message = '';
    //   await this.validate();
    //   if(this.valid == true){
    //     this.activation.MakerID = this.currentUser.SecurityUserID
    //     this.activation.LastUserID = this.currentUser.SecurityUserID,
    //     this.createActivation(this.activation)
    //     .then(response =>{
    //       this.$socket.client.emit('socketreq', {
    //         commit: 'newActivation',
    //         data: response.data
    //       });
    //       this.message = response.data.message
    //       this.reset()
    //       this.closeCreate()
    //     },
    //     error => {
    //     this.message =
    //       (error.response && error.response.data.message) ||
    //       error.message ||
    //       error.toString();
    //     })        
    //   }
    // },

    // async update() {
    //   this.message = '';
    //   await this.validate();
    //   if(this.valid == true){
    //     if(this.currentSettlement.CheckerID == 0){
    //       this.currentSettlement.LastUserID = this.currentUser.SecurityUserID,
    //       this.currentSettlement.RejectionID = this.RejectionStatus,
    //       this.currentSettlement.CheckerID = 0,
    //       this.currentSettlement.CheckDate = null,

    //       this.updateActivation(this.currentSettlement)
    //       .then(response => {
    //         this.$socket.client.emit('socketreq', {
    //           commit: 'updActivation',
    //           data: this.currentSettlement
    //         });
    //         console.log(response.data)
    //         this.message = response.data.message
    //         this.closeEdit()
    //       },
    //       error => {
    //       this.message =
    //         (error.response && error.response.data.message) ||
    //         error.message ||
    //         error.toString();
    //       })
    //     } else {
    //       this.currentSettlement.MakerID = this.currentUser.SecurityUserID
    //       this.currentSettlement.LastUserID = this.currentUser.SecurityUserID,
    //       this.currentSettlement.RejectionID = this.RejectionStatus,
    //       this.currentSettlement.CheckerID = 0,
    //       this.currentSettlement.CheckDate = null,
    //       this.currentSettlement.MakeDate = new Date(),

    //       this.updateActivation(this.currentSettlement)
    //       .then(response => {
    //         this.$socket.client.emit('socketreq', {
    //           commit: 'updActivation',
    //           data: this.currentSettlement
    //         });
    //         console.log(response.data)
    //         this.message = response.data.message
    //         this.closeEdit()
    //       },
    //       error => {
    //       this.message =
    //         (error.response && error.response.data.message) ||
    //         error.message ||
    //         error.toString();
    //       })
    //     }
    //   }
    // },

    // deleteItem() {
    //   this.message = '';

    //   this.deleteActivation(this.currentSettlement)
    //   .then(response => {
    //     this.$socket.client.emit('socketreq', {
    //       commit: 'dltActivation',
    //       data: this.currentSettlement
    //     });
    //     console.log(response.data)
    //     this.message = response.data.message
    //     this.deleteDialog = false
    //   },
    //   error => {
    //   this.message =
    //     (error.response && error.response.data.message) ||
    //     error.message ||
    //     error.toString();
    //   })
    // },

    // updateStatus() {
    //   this.message = '';

    //   this.currentSettlement.CheckerID = this.currentUser.SecurityUserID,
    //   this.currentSettlement.LastUserID = this.currentUser.SecurityUserID,
    //   this.currentSettlement.RejectionID = this.RejectionStatus,
    //   this.currentSettlement.CheckDate = new Date(),
    //   this.currentSettlement.updatedAt = new Date(),

    //   this.updateActivation(this.currentSettlement)
    //   .then(response => {
    //     this.$socket.client.emit('socketreq', {
    //       commit: 'updActivation',
    //       data: this.currentSettlement
    //     });
    //     console.log(response.data)
    //     this.message = response.data.message
    //     this.RejectionStatus = 0
    //     this.rejectionDialog = false
    //   },
    //   error => {
    //   this.message =
    //     (error.response && error.response.data.message) ||
    //     error.message ||
    //     error.toString();
    //   })
    // },

    // unconfirmed() {
    //   this.confirmedActivations = false
    // },

    // showEdit () {
    //   this.edit = true
    // },

    // closeEdit() {
    //   this.edit = false
    // },

    // showCreate () {
    //   this.create = true
    // },

    // closeCreate() {
    //   this.create = false
    //   this.reset()
    // },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    // validate () {
    //   this.$refs.form.validate()
    // },

    // reset () {
    //   this.$refs.form.reset()
    // },

    setActiveSettlement (item, index) {
      this.currentSettlement = item
      this.currentIndex = index
    },
  },

  mounted () {
    UserService.isSettlement().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
    // this.$root.$on("unconfirmedActivations", () => {
    //   this.unconfirmed();
    // });
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.v-btn {
  outline: none
}

.edit {
  background-color: #DBEFFA;
}

.headline {
  color:white
}
</style>
